import React from 'react';
// import { Container, Row, Col } from 'react-bootstrap';

class Recipes extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            debug: true,
        };
    }

    componentDidMount() {}

    render() {
        return (
            <>hello, world</>
        )
    }
}

export default Recipes;
